'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
export const Toolbar = (_a) => {
    var { behavior, className, children, verticalAlign } = _a, other = __rest(_a, ["behavior", "className", "children", "verticalAlign"]);
    const [isEnd, setIsEnd] = React.useState(true);
    const [isStart, setIsStart] = React.useState(false);
    const toolbarRef = React.useRef(null);
    const toolbarListContainerRef = React.useRef(null);
    const toolbarListRef = React.useRef(null);
    const setShadows = () => {
        if (!toolbarRef.current)
            return;
        if (!toolbarListRef.current)
            return;
        if (!toolbarListContainerRef.current)
            return;
        const toolbarWidth = toolbarRef.current.clientWidth;
        const toolbarListWidth = toolbarListRef.current.clientWidth - 8;
        const toolbarOffScreen = toolbarListWidth - toolbarRef.current.clientWidth;
        if (toolbarListWidth <= toolbarWidth) {
            setIsEnd(false);
            setIsStart(false);
        }
        else if (toolbarListContainerRef.current.scrollLeft > 0 &&
            toolbarListContainerRef.current.scrollLeft < toolbarOffScreen) {
            setIsEnd(true);
            setIsStart(true);
        }
        else if (toolbarListContainerRef.current.scrollLeft >= toolbarOffScreen) {
            setIsEnd(false);
            setIsStart(true);
        }
        else {
            setIsEnd(true);
            setIsStart(false);
        }
    };
    const handleOnScroll = () => {
        setShadows();
    };
    React.useEffect(() => {
        setShadows();
        window.addEventListener('resize', setShadows);
        return () => {
            window.removeEventListener('resize', setShadows);
        };
    });
    const componentClassName = classnames('sparky-c-toolbar', className, {
        'sparky-c-toolbar--vertical-align-bottom': verticalAlign === 'bottom',
        'sparky-c-toolbar--vertical-align-top': verticalAlign === 'top',
        'sparky-c-toolbar--overflow': behavior === 'overflow',
        'sparky-is-overflow-left': isStart,
        'sparky-is-overflow-right': isEnd,
    });
    return (_jsx("div", Object.assign({ className: componentClassName, ref: toolbarRef }, other, { children: _jsx("div", Object.assign({ className: "sparky-c-toolbar__inner" }, { children: _jsx("div", Object.assign({ className: "sparky-c-toolbar__list-container", ref: toolbarListContainerRef, onScroll: handleOnScroll }, { children: _jsx("ul", Object.assign({ className: "sparky-c-toolbar__list", ref: toolbarListRef }, { children: children })) })) })) })));
};
//# sourceMappingURL=Toolbar.js.map